<template>
  <div class="comWrap">
    <div class="comItemWrap">
<!--      <div class="comItemTiitle">AI环保定制方案</div>-->
      <div class="imgComWrap">
        <img src="../imgs/com5.jpg" style="width: 100%;" alt="">
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data() {
      return {
        info: "",
        list:[
          {
            title:"指标因子定制",
            content:"标准六参/七参/定制：PM2.5、PM10、SO2、NO2、CO、O3、TVOC、HCN、HF、HCl、<br>" +
              "扬尘类型：PM1.0、 PM2.5、PM10、TSP<br>" +
              "恶臭类型：TVOC、恶臭OU、H2S、NH3、甲硫醚、甲硫醇、二甲二硫、二硫化碳、苯乙烯、三甲胺<br>" +
              "温室气体类型：CO₂、CH₄、H2O、N2O、CO、H2、 NH3<br>" +
              "气象类型：微气象五参(风速、风向、温度、湿度、气压)、噪声<br>"
          },
          {
            title:"结构定制",
            content:"固定式、车载式、便携式手提箱、无人机机载"
          },
          {
            title:"产品功能定制",
            content:"4路1080P音视频功能、双向对讲/单向喊话<br>" +
              "多种供电方式：市电/太阳能/车载/可充电电池、<br>" +
              "低功耗、超长待机<br>" +
              "宽幅电源输入、断电保护功能<br>" +
              "告警联动图片抓拍、告警视频上传<br>" +
              "长时间告警、多次告警自动生成处理工单<br>"
          }
        ]
      }
    },
    created() {
    },
    components: {},
    methods: {}
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "~@/common/stylus/mixin.styl"
  .comWrap
    .comItemWrap
      margin-bottom 30px
      .comItemTiitle
        font-size 20px
        font-weight bold
        padding 15px 30px
        background-color #3E85F1
        border-radius 10px
        border 1px solid #072655
        display inline-block
        color white
      .imgComWrap
        width 100%
        margin-top 20px
</style>



// WEBPACK FOOTER //
// src/views/solution/components/com0.vue